import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Collection } from 'core/model';
import { observable } from 'mobx';
export var DeviceSyslogsCollection = (_dec = observable.ref, _class = /*#__PURE__*/function (_Collection) {
  function DeviceSyslogsCollection(device) {
    var _this;
    _classCallCheck(this, DeviceSyslogsCollection);
    _this = _callSuper(this, DeviceSyslogsCollection);
    _initializerDefineProperty(_this, "device", _descriptor, _this);
    _this.device = device;
    _this.requestStatus = 'awaitingRequest';
    return _this;
  }
  _inherits(DeviceSyslogsCollection, _Collection);
  return _createClass(DeviceSyslogsCollection, [{
    key: "url",
    get: function get() {
      return "/api/ui/devices/".concat(this.device.id, "/syslog/query");
    }
  }, {
    key: "fetchMethod",
    get: function get() {
      return 'post';
    }
  }]);
}(Collection), _descriptor = _applyDecoratedDescriptor(_class.prototype, "device", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);